import { isArray } from './type';
export var classGetter = function classGetter() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (name) {
    return isArray(classes[name]) ? classes[name].join(' ') : classes[name];
  };
};